type Props = {
  subtitle: string
  description?: string
}

export const CardsCreateHeader = ({ subtitle, description }: Props) => {
  return (
    <div className="main-form-cards_header">
      <div className="main-form-cards_subtitle">{subtitle}</div>
      {description && <div className="main-form-cards_description">{description}</div>}
    </div>
  )
}
